export const TABLE_WIDTH_STORAGE_PLACE = 200
export const TABLE_WIDTH_BRAND = 200
export const TABLE_WIDTH_MODEL = 200
export const TABLE_WIDTH_FOUND = 160
export const TABLE_WIDTH_PLATE = 150
export const TABLE_WIDTH_PARTNER = 200
export const TABLE_WIDTH_DOT_CHOICE = 30
export const TABLE_WIDTH_ICON = 50

export const TABLE_WIDTH_INVENTORY_BRAND_FILTER = 122
export const TABLE_WIDTH_INVENTORY_MODEL_FILTER = 122
export const TABLE_WIDTH_INVENTORY_DATE_FILTER = 180
export const TABLE_WIDTH_INVENTORY_KM = 122
export const TABLE_WIDTH_INVENTORY_PARTNER = 110
export const TABLE_WIDTH_INVENTORY_PLATE = 80
export const TABLE_WIDTH_INVENTORY_PRICE_CHANGE_COUNT = 130
export const TABLE_WIDTH_INVENTORY_DAYS = 90
export const TABLE_WIDTH_INVENTORY_LEAD = 50
export const TABLE_WIDTH_INVENTORY_SUGGESTED_PRICE = 80
export const TABLE_WIDTH_INVENTORY_FEE = 85

export const TABLE_ROWS_PER_PAGE = 10
export const TABLE_ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100]

export const TABLE_DIRECTION_ASC = 'asc'
export const TABLE_DIRECTION_DESC = 'desc'
